import script from "./ProductAttributeValueIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAttributeValueIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAttributeValueIcon.vue?vue&type=style&index=0&id=445cc839&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-445cc839"]])

export default __exports__